import { gql } from '@apollo/client';

export const DELETE_ATHLETE = gql`
    mutation deleteUser($idUser: ID!){
        deleteUser(idUser: $idUser)
    }
`;
